// Main javascript entry point
// Should handle bootstrapping/starting application


'use strict';

import $ from 'jquery';
import Search from '../_modules/search/search';
import Menu from '../_modules/menu/menu';
import Banner from '../_modules/banner/banner';
import Profile from '../_modules/profile/profile';
import News from '../_modules/news-events/news';
import Gallery from '../_modules/gallery/gallery';
import Application from '../_modules/form/Application';

$(() => {

    $('html').removeClass('no-js');
    if(navigator.userAgent.indexOf('Mac') > 0){
        $('body').addClass('mac-os');
    }

    $('video').on('click', function(){
        this.paused ? this.play() : this.pause();
        $('.field--name-field-homepage-video-banner .play').toggle();
    });

    var $mobile = $(window).outerWidth() < 768;

    if(!$mobile){
        $('video').attr('autoplay','true');

        $('.icon-scrolldown').on('click',function(){
            $("html, body").animate({ scrollTop: $('.school-block').offset().top -70 }, 500);
        })
    } else {
        $('.field--name-field-banner').each(function(){
            var $mobile = $(this).data('mobile'),
                $mobileIMG = $(this).find('img').data('mobile');

            $(this).attr("data-src", $mobile);
            $(this).find('img').attr('src',$mobileIMG);
        });
    }

    $('.map-link').on('click',function(){
        $("html, body").animate({ scrollTop: $('.map').offset().top -70 }, 500);
    })

    new Search();
    new Menu();
    new Banner();
    new Profile();
    new News();
    new Gallery();
    new Application();

	/**
	* jquery-match-height master by @liabru
	* http://brm.io/jquery-match-height/
	* License: MIT
	*/

	(function(factory) { // eslint-disable-line no-extra-semi
		'use strict';
		if (typeof define === 'function' && define.amd) {
			// AMD
			define(['jquery'], factory);
		} else if (typeof module !== 'undefined' && module.exports) {
			// CommonJS
			module.exports = factory(require('jquery'));
		} else {
			// Global
			factory(jQuery);
		}
	})(function($) {
		/*
		*  internal
		*/

		var _previousResizeWidth = -1,
			_updateTimeout = -1;

		/*
		*  _parse
		*  value parse utility function
		*/

		var _parse = function(value) {
			// parse value and convert NaN to 0
			return parseFloat(value) || 0;
		};

		/*
		*  _rows
		*  utility function returns array of jQuery selections representing each row
		*  (as displayed after float wrapping applied by browser)
		*/

		var _rows = function(elements) {
			var tolerance = 1,
				$elements = $(elements),
				lastTop = null,
				rows = [];

			// group elements by their top position
			$elements.each(function(){
				var $that = $(this),
					top = $that.offset().top - _parse($that.css('margin-top')),
					lastRow = rows.length > 0 ? rows[rows.length - 1] : null;

				if (lastRow === null) {
					// first item on the row, so just push it
					rows.push($that);
				} else {
					// if the row top is the same, add to the row group
					if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {
						rows[rows.length - 1] = lastRow.add($that);
					} else {
						// otherwise start a new row group
						rows.push($that);
					}
				}

				// keep track of the last row top
				lastTop = top;
			});

			return rows;
		};

		/*
		*  _parseOptions
		*  handle plugin options
		*/

		var _parseOptions = function(options) {
			var opts = {
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			};

			if (typeof options === 'object') {
				return $.extend(opts, options);
			}

			if (typeof options === 'boolean') {
				opts.byRow = options;
			} else if (options === 'remove') {
				opts.remove = true;
			}

			return opts;
		};

		/*
		*  matchHeight
		*  plugin definition
		*/

		var matchHeight = $.fn.matchHeight = function(options) {
			var opts = _parseOptions(options);

			// handle remove
			if (opts.remove) {
				var that = this;

				// remove fixed height from all selected elements
				this.css(opts.property, '');

				// remove selected elements from all groups
				$.each(matchHeight._groups, function(key, group) {
					group.elements = group.elements.not(that);
				});

				// TODO: cleanup empty groups

				return this;
			}

			if (this.length <= 1 && !opts.target) {
				return this;
			}

			// keep track of this group so we can re-apply later on load and resize events
			matchHeight._groups.push({
				elements: this,
				options: opts
			});

			// match each element's height to the tallest element in the selection
			matchHeight._apply(this, opts);

			return this;
		};

		/*
		*  plugin global options
		*/

		matchHeight.version = 'master';
		matchHeight._groups = [];
		matchHeight._throttle = 80;
		matchHeight._maintainScroll = false;
		matchHeight._beforeUpdate = null;
		matchHeight._afterUpdate = null;
		matchHeight._rows = _rows;
		matchHeight._parse = _parse;
		matchHeight._parseOptions = _parseOptions;

		/*
		*  matchHeight._apply
		*  apply matchHeight to given elements
		*/

		matchHeight._apply = function(elements, options) {
			var opts = _parseOptions(options),
				$elements = $(elements),
				rows = [$elements];

			// take note of scroll position
			var scrollTop = $(window).scrollTop(),
				htmlHeight = $('html').outerHeight(true);

			// get hidden parents
			var $hiddenParents = $elements.parents().filter(':hidden');

			// cache the original inline style
			$hiddenParents.each(function() {
				var $that = $(this);
				$that.data('style-cache', $that.attr('style'));
			});

			// temporarily must force hidden parents visible
			$hiddenParents.css('display', 'block');

			// get rows if using byRow, otherwise assume one row
			if (opts.byRow && !opts.target) {

				// must first force an arbitrary equal height so floating elements break evenly
				$elements.each(function() {
					var $that = $(this),
						display = $that.css('display');

					// temporarily force a usable display value
					if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
						display = 'block';
					}

					// cache the original inline style
					$that.data('style-cache', $that.attr('style'));

					$that.css({
						'display': display,
						'padding-top': '0',
						'padding-bottom': '0',
						'margin-top': '0',
						'margin-bottom': '0',
						'border-top-width': '0',
						'border-bottom-width': '0',
						'height': '100px',
						'overflow': 'hidden'
					});
				});

				// get the array of rows (based on element top position)
				rows = _rows($elements);

				// revert original inline styles
				$elements.each(function() {
					var $that = $(this);
					$that.attr('style', $that.data('style-cache') || '');
				});
			}

			$.each(rows, function(key, row) {
				var $row = $(row),
					targetHeight = 0;

				if (!opts.target) {
					// skip apply to rows with only one item
					if (opts.byRow && $row.length <= 1) {
						$row.css(opts.property, '');
						return;
					}

					// iterate the row and find the max height
					$row.each(function(){
						var $that = $(this),
							style = $that.attr('style'),
							display = $that.css('display');

						// temporarily force a usable display value
						if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
							display = 'block';
						}

						// ensure we get the correct actual height (and not a previously set height value)
						var css = { 'display': display };
						css[opts.property] = '';
						$that.css(css);

						// find the max height (including padding, but not margin)
						if ($that.outerHeight(false) > targetHeight) {
							targetHeight = $that.outerHeight(false);
						}

						// revert styles
						if (style) {
							$that.attr('style', style);
						} else {
							$that.css('display', '');
						}
					});
				} else {
					// if target set, use the height of the target element
					targetHeight = opts.target.outerHeight(false);
				}

				// iterate the row and apply the height to all elements
				$row.each(function(){
					var $that = $(this),
						verticalPadding = 0;

					// don't apply to a target
					if (opts.target && $that.is(opts.target)) {
						return;
					}

					// handle padding and border correctly (required when not using border-box)
					if ($that.css('box-sizing') !== 'border-box') {
						verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
						verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
					}

					// set the height (accounting for padding and border)
					$that.css(opts.property, (targetHeight - verticalPadding) + 'px');
				});
			});

			// revert hidden parents
			$hiddenParents.each(function() {
				var $that = $(this);
				$that.attr('style', $that.data('style-cache') || null);
			});

			// restore scroll position if enabled
			if (matchHeight._maintainScroll) {
				$(window).scrollTop((scrollTop / htmlHeight) * $('html').outerHeight(true));
			}

			return this;
		};

		/*
		*  matchHeight._applyDataApi
		*  applies matchHeight to all elements with a data-match-height attribute
		*/

		matchHeight._applyDataApi = function() {
			var groups = {};

			// generate groups by their groupId set by elements using data-match-height
			$('[data-match-height], [data-mh]').each(function() {
				var $this = $(this),
					groupId = $this.attr('data-mh') || $this.attr('data-match-height');

				if (groupId in groups) {
					groups[groupId] = groups[groupId].add($this);
				} else {
					groups[groupId] = $this;
				}
			});

			// apply matchHeight to each group
			$.each(groups, function() {
				this.matchHeight(true);
			});
		};

		/*
		*  matchHeight._update
		*  updates matchHeight on all current groups with their correct options
		*/

		var _update = function(event) {
			if (matchHeight._beforeUpdate) {
				matchHeight._beforeUpdate(event, matchHeight._groups);
			}

			$.each(matchHeight._groups, function() {
				matchHeight._apply(this.elements, this.options);
			});

			if (matchHeight._afterUpdate) {
				matchHeight._afterUpdate(event, matchHeight._groups);
			}
		};

		matchHeight._update = function(throttle, event) {
			// prevent update if fired from a resize event
			// where the viewport width hasn't actually changed
			// fixes an event looping bug in IE8
			if (event && event.type === 'resize') {
				var windowWidth = $(window).width();
				if (windowWidth === _previousResizeWidth) {
					return;
				}
				_previousResizeWidth = windowWidth;
			}

			// throttle updates
			if (!throttle) {
				_update(event);
			} else if (_updateTimeout === -1) {
				_updateTimeout = setTimeout(function() {
					_update(event);
					_updateTimeout = -1;
				}, matchHeight._throttle);
			}
		};

		/*
		*  bind events
		*/

		// apply on DOM ready event
		$(matchHeight._applyDataApi);

		// use on or bind where supported
		var on = $.fn.on ? 'on' : 'bind';

		// update heights on load and resize events
		$(window)[on]('load', function(event) {
			matchHeight._update(false, event);
		});

		// throttled update heights on resize events
		$(window)[on]('resize orientationchange', function(event) {
			matchHeight._update(true, event);
		});

	});

	/* MatchHeight Init */
	$('.group-items .news-item .details').matchHeight();
	jQuery(document).ajaxComplete(function() {
		if ($('.group-items .news-item .details').length) {
			$('.group-items .news-item .details').matchHeight();
		}
	});


    (function($, window, document, undefined) {
		var $window = $(window);

		$.fn.lazyload = function(options) {
			var elements = this;
			var $container;
			var settings = {
				threshold       : 0,
				failure_limit   : 0,
				event           : "scroll",
				effect          : "show",
				container       : window,
				data_attribute  : "src",
				skip_invisible  : false,
				appear          : null,
				load            : null,
				placeholder     : "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iMzIwcHgiIGhlaWdodD0iMjQwcHgiIHZpZXdCb3g9IjAgMCAzMjAgMjQwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMjAgMjQwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxyZWN0IGZpbGw9IiNFRUVFRUUiIHdpZHRoPSIzMjAiIGhlaWdodD0iMjQwIi8+DQo8cGF0aCBmaWxsPSJub25lIiBkPSJNMTM3LDk2aDQ4djQ4aC00OFY5NnoiLz4NCjxwYXRoIGZpbGw9IiM2NjY2NjYiIGQ9Ik0xNzksMTM0di0yOGMwLTIuMi0xLjgtNC00LTRoLTI4Yy0yLjIsMC00LDEuOC00LDR2MjhjMCwyLjIsMS44LDQsNCw0aDI4QzE3Ny4yLDEzOCwxNzksMTM2LjIsMTc5LDEzNHoNCgkgTTE1NCwxMjNsNSw2LjAybDctOS4wMmw5LDEyaC0yOEwxNTQsMTIzeiIvPg0KPC9zdmc+DQo="
				// placeholder     : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
			};

			function update() {
				var counter = 0;

				elements.each(function() {
					var $this = $(this);
					if (settings.skip_invisible && !$this.is(":visible")) {
						return;
					}
					if ($.abovethetop(this, settings) ||
						$.leftofbegin(this, settings)) {
							/* Nothing. */
					} else if (!$.belowthefold(this, settings) &&
						!$.rightoffold(this, settings)) {
							$this.trigger("appear");
							/* if we found an image we'll load, reset the counter */
							counter = 0;
					} else {
						if (++counter > settings.failure_limit) {
							return false;
						}
					}
				});

			}

			if(options) {
				/* Maintain BC for a couple of versions. */
				if (undefined !== options.failurelimit) {
					options.failure_limit = options.failurelimit;
					delete options.failurelimit;
				}
				if (undefined !== options.effectspeed) {
					options.effect_speed = options.effectspeed;
					delete options.effectspeed;
				}

				$.extend(settings, options);
			}

			/* Cache container as jQuery as object. */
			$container = (settings.container === undefined ||
						settings.container === window) ? $window : $(settings.container);

			/* Fire one scroll event per scroll. Not one scroll event per image. */
			if (0 === settings.event.indexOf("scroll")) {
				$container.bind(settings.event, function() {
					return update();
				});
			}

			this.each(function() {
				var self = this;
				var $self = $(self);

				self.loaded = false;

				/* If no src attribute given use data:uri. */
				if ($self.attr("src") === undefined || $self.attr("src") === false) {
					if ($self.is("img")) {
						$self.attr("src", settings.placeholder);
					}
				}

				/* When appear is triggered load original image. */
				$self.one("appear", function() {
					if (!this.loaded) {
						if (settings.appear) {
							var elements_left = elements.length;
							settings.appear.call(self, elements_left, settings);
						}
						$("<img />")
							.bind("load", function() {

								var original = $self.attr("data-" + settings.data_attribute);
								$self.hide();
								if ($self.is("img")) {
									$self.attr("src", original);
								} else {
									$self.css("background-image", "url('" + original + "')");
								}
								$self[settings.effect](settings.effect_speed);

								self.loaded = true;

								/* Remove image from array so it is not looped next time. */
								var temp = $.grep(elements, function(element) {
									return !element.loaded;
								});
								elements = $(temp);

								if (settings.load) {
									var elements_left = elements.length;
									settings.load.call(self, elements_left, settings);
								}
							})
							.attr("src", $self.attr("data-" + settings.data_attribute));
					}
				});

				/* When wanted event is triggered load original image */
				/* by triggering appear.                              */
				if (0 !== settings.event.indexOf("scroll")) {
					$self.bind(settings.event, function() {
						if (!self.loaded) {
							$self.trigger("appear");
						}
					});
				}
			});

			/* Check if something appears when window is resized. */
			$window.bind("resize", function() {
				update();
			});

			/* With IOS5 force loading images when navigating with back button. */
			/* Non optimal workaround. */
			if ((/(?:iphone|ipod|ipad).*os 5/gi).test(navigator.appVersion)) {
				$window.bind("pageshow", function(event) {
					if (event.originalEvent && event.originalEvent.persisted) {
						elements.each(function() {
							$(this).trigger("appear");
						});
					}
				});
			}

			/* Force initial check if images should appear. */
			$(document).ready(function() {
				update();
			});

			return this;
		};

		/* Convenience methods in jQuery namespace.           */
		/* Use as  $.belowthefold(element, {threshold : 100, container : window}) */

		$.belowthefold = function(element, settings) {
			var fold;

			if (settings.container === undefined || settings.container === window) {
				fold = (window.innerHeight ? window.innerHeight : $window.height()) + $window.scrollTop();
			} else {
				fold = $(settings.container).offset().top + $(settings.container).height();
			}

			return fold <= $(element).offset().top - settings.threshold;
		};

		$.rightoffold = function(element, settings) {
			var fold;

			if (settings.container === undefined || settings.container === window) {
				fold = $window.width() + $window.scrollLeft();
			} else {
				fold = $(settings.container).offset().left + $(settings.container).width();
			}

			return fold <= $(element).offset().left - settings.threshold;
		};

		$.abovethetop = function(element, settings) {
			var fold;

			if (settings.container === undefined || settings.container === window) {
				fold = $window.scrollTop();
			} else {
				fold = $(settings.container).offset().top;
			}

			return fold >= $(element).offset().top + settings.threshold  + $(element).height();
		};

		$.leftofbegin = function(element, settings) {
			var fold;

			if (settings.container === undefined || settings.container === window) {
				fold = $window.scrollLeft();
			} else {
				fold = $(settings.container).offset().left;
			}

			return fold >= $(element).offset().left + settings.threshold + $(element).width();
		};

		$.inviewport = function(element, settings) {
			return !$.rightoffold(element, settings) && !$.leftofbegin(element, settings) &&
					!$.belowthefold(element, settings) && !$.abovethetop(element, settings);
		};

		/* Custom selectors for your convenience.   */
		/* Use as $("img:below-the-fold").something() or */
		/* $("img").filter(":below-the-fold").something() which is faster */

		$.extend($.expr[":"], {
			"below-the-fold" : function(a) { return $.belowthefold(a, {threshold : 0}); },
			"above-the-top"  : function(a) { return !$.belowthefold(a, {threshold : 0}); },
			"right-of-screen": function(a) { return $.rightoffold(a, {threshold : 0}); },
			"left-of-screen" : function(a) { return !$.rightoffold(a, {threshold : 0}); },
			"in-viewport"    : function(a) { return $.inviewport(a, {threshold : 0}); },
			/* Maintain BC for couple of versions. */
			"above-the-fold" : function(a) { return !$.belowthefold(a, {threshold : 0}); },
			"right-of-fold"  : function(a) { return $.rightoffold(a, {threshold : 0}); },
			"left-of-fold"   : function(a) { return !$.rightoffold(a, {threshold : 0}); }
		});

	})(jQuery, window, document);


    jQuery(document).ready(function ($) {
        //Init Lazy Loading
        $('.lazy').lazyload({
            load : function() {
                var $this = $(this);
                if(!$this.attr('src')){
                    $this.addClass('sharpen');
                    //$this.find(".tiny-img").fadeOut();
                }
            }
		});
		
		$("input").focus(function(){
			var elementOffset = $(this).offset().top,
			scrollTop     = $(window).scrollTop(),
			distance      = (elementOffset - scrollTop);
	  
			var addSpace = 80 - distance;
	  
			if(addSpace > 0)
			{
				console.log(addSpace);
				var y = $(window).scrollTop();  
				$(window).scrollTop(y-addSpace);
			}
		});
    });

    $('.lazy .tiny-img').each(function() {
      // if the image height is less than the holder
      // set a min for the tiny image to keep it proporsional
      var $this = $(this),
          $parent = $this.parent('.lazy'),
          parentH = $parent.outerHeight(),
          imgH = $this.height(),
          imgOriginalH = $this.attr("height"),
          imgOriginalW = $this.attr("width"),
          imgW =  parentH / imgOriginalH * imgOriginalW;

      $this.css("opacity", "1");

      if (parentH > imgH) {
        $this.css({
          "min-width": imgW,
          "height": "100%",
          "width": "auto"
        });
      }
    });

});
